module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-divider', [_vm._v("我加入的俱乐部")]), _vm._v(" "), (_vm.row.club.id) ? _c('van-cell-group', [(_vm.row.club.registstatus == 2) ? _c('van-cell', {
    attrs: {
      "title": _vm.row.club.danwei,
      "value": "审核成功",
      "is-link": ""
    },
    on: {
      "click": _vm.goClub
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-0",
          staticStyle: {
            "display": "block",
            "float": "left",
            "margin-right": "10px"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.unbindClub()
            }
          }
        }, [_vm._v("解除绑定")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.row.club_list.length > 1),
            expression: "row.club_list.length>1"
          }],
          staticClass: "tiny-btn-0",
          staticStyle: {
            "display": "block",
            "float": "left"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.sheetActiveShow = true
            }
          }
        }, [_vm._v("切换俱乐部")])]
      },
      proxy: true
    }], null, false, 3639715564)
  }) : _c('van-cell', {
    attrs: {
      "title": _vm.row.club.danwei,
      "value": _vm.row.club.registstatus == 1 ? '等待审核' : ''
    },
    on: {
      "click": function($event) {
        return _vm.toClubNext(_vm.row.club.id)
      }
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("查看详情")])]
      },
      proxy: true
    }], null, false, 1929795839)
  })], 1) : _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "新增俱乐部"
    },
    on: {
      "click": _vm.toClub
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("点击创建")])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("我的考级中心（点）")]), _vm._v(" "), (_vm.row.center.id) ? _c('van-cell-group', [(_vm.row.center.kaojiregist_status == 2) ? _c('van-cell', {
    attrs: {
      "title": _vm.row.center.danwei,
      "value": "审核成功",
      "is-link": ""
    },
    on: {
      "click": _vm.goCenter
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-0",
          staticStyle: {
            "display": "block",
            "float": "left",
            "margin-right": "10px"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.unbindCenter()
            }
          }
        }, [_vm._v("解除绑定")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.row.center_list.length > 1),
            expression: "row.center_list.length>1"
          }],
          staticClass: "tiny-btn-0",
          staticStyle: {
            "display": "block",
            "float": "left"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.centerActiveShow = true
            }
          }
        }, [_vm._v("切换考级中心/点")])]
      },
      proxy: true
    }], null, false, 3046529038)
  }) : _c('van-cell', {
    attrs: {
      "title": _vm.row.center.danwei,
      "value": _vm.row.center.kaojiregist_status == 1 ? '等待审核' : ''
    },
    on: {
      "click": function($event) {
        return _vm.toKaojiNext(_vm.row.center.id)
      }
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("查看详情")])]
      },
      proxy: true
    }], null, false, 1929795839)
  })], 1) : _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "考级中心/考级点"
    },
    on: {
      "click": _vm.toKaoji
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("点击创建")])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toKaoji
    }
  }, [_vm._v("创建考级中心（点）\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    staticClass: "dialog-box",
    attrs: {
      "title": "",
      "showConfirmButton": false
    },
    model: {
      value: (_vm.clubShow),
      callback: function($$v) {
        _vm.clubShow = $$v
      },
      expression: "clubShow"
    }
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_vm._v("创建须知")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("附件下载\n"), _vm._v(" "), _c('div', [_c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.download('啦啦操星级俱乐部管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf')
      }
    }
  }, [_vm._v("\n            啦啦操星级俱乐部管理办法\n          ")])], 1)]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.toClubNext(0)
      }
    }
  }, [_c('div', [_vm._v("我已阅读并同意遵守本须知声明的所有条款")]), _vm._v(" "), _c('div', [_vm._v("点击进行创建")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.clubShow = false
      }
    }
  }, [_vm._v("我再想想")])], 1)]), _vm._v(" "), _c('van-dialog', {
    staticClass: "dialog-box",
    attrs: {
      "title": "",
      "showConfirmButton": false
    },
    model: {
      value: (_vm.kaojiShow),
      callback: function($$v) {
        _vm.kaojiShow = $$v
      },
      expression: "kaojiShow"
    }
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_vm._v("创建须知")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("1.可创建类型为：")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（1）七彩星级考级点（预备）0元")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("0元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（2）七彩星级指定样板考级点")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("9800元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（3）七彩星级指定样板考级中心")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("135000元")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("2.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("3.附件下载\n          "), _c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download('啦啦操七彩星级管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-14.pdf')
      }
    }
  }, [_vm._v("\n            啦啦操七彩星级管理办法\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download('七彩星级考级中心（点）加盟方案', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-12.pdf')
      }
    }
  }, [_vm._v("\n            七彩星级考级中心（点）加盟方案\n          ")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.toKaojiNext(0)
      }
    }
  }, [_c('div', [_vm._v("我已阅读并同意遵守本须知声明的所有条款")]), _vm._v(" "), _c('div', [_vm._v("点击进行创建")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.kaojiShow = false
      }
    }
  }, [_vm._v("我再想想")])], 1)]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "将以新的俱乐部主体参赛报名",
      "actions": _vm.row.club_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetActiveShow),
      callback: function($$v) {
        _vm.sheetActiveShow = $$v
      },
      expression: "sheetActiveShow"
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "将以考级中心/点申报考级",
      "actions": _vm.row.center_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelectCenter
    },
    model: {
      value: (_vm.centerActiveShow),
      callback: function($$v) {
        _vm.centerActiveShow = $$v
      },
      expression: "centerActiveShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ece8a3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubIndex.vue
// module id = 2313
// module chunks = 0